import { ReactElement, useCallback } from 'react';

import { TranslatableText } from '@dreryk/react-common';
import { AddCircleIcon, Link } from '@dreryk/react-components';

import {
   HealthcareProviderPatientPortalBoundServiceCreateModal,
   useHealthcareProviderPatientPortalBoundServiceCreateModalState,
} from './healthcareProviderPatientPortalBoundServiceCreate/HealthcareProviderPatientPortalBoundServiceCreateModal';

type AddNewBoundServiceModalOpenerProps = {
   readonly withLeadingIcon: boolean;
   readonly label: TranslatableText;
   readonly onBoundServiceCreateSuccess: VoidFunction;
};

export const AddNewBoundServiceModalOpener = (props: AddNewBoundServiceModalOpenerProps): ReactElement => {
   const [
      openBoundServiceCreateModal,
      closeBoundServiceCreateModal,
      boundServiceModalOpened,
   ] = useHealthcareProviderPatientPortalBoundServiceCreateModalState();

   const handleBoundServiceCreateSuccess = useCallback(() => {
      closeBoundServiceCreateModal();
      props.onBoundServiceCreateSuccess();
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [closeBoundServiceCreateModal, props.onBoundServiceCreateSuccess]);
   return (
      <>
         <Link
            testId={'addNewBoundService'}
            onClick={openBoundServiceCreateModal}
            label={props.label}
            icon={props.withLeadingIcon ? <AddCircleIcon /> : undefined}
         />
         {boundServiceModalOpened ? (
            <HealthcareProviderPatientPortalBoundServiceCreateModal
               onBoundServiceCreateSuccess={handleBoundServiceCreateSuccess}
               onClose={closeBoundServiceCreateModal}
            />
         ) : null}
      </>
   );
};
